"use strict";

var _classCallCheck = require("E:\\Blockchain\\prnts_main_repo\\PrntPlace-main\\client\\node_modules\\@babel\\runtime/helpers/classCallCheck");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IJsonRpcRouter = void 0;

var IJsonRpcRouter = function IJsonRpcRouter(routes) {
  _classCallCheck(this, IJsonRpcRouter);

  this.routes = routes;
};

exports.IJsonRpcRouter = IJsonRpcRouter;